import create from "zustand";

import {
  GetTitleDocumentFunction,
  GetTitleDocumentsFunction,
  GetTitlesFunction,
  GetTitleStatusFunction,
  UploadTitleDocumentFunction,
} from "types/functions";
import {
  EndpointDownloadedTitleDocument,
  EndpointTitle,
  EndpointTitleDocument,
  EndpointTitleStatus,
  TitleCompanies,
} from "types/entities";
import { TitleService } from "services";
import {} from "types/functions";
import { GetTitleCompaniesFunction } from "types/functions/getTitleCompanies";
import { CreateTitleCompanyFunction } from "types/functions/createTitleCompany";
import { RemoveTitleCompanyFunction } from "types/functions/removeTitleCompany";

interface TitleStore {
  titles: EndpointTitle[];
  titleCompanies: TitleCompanies[];
  titleStatus: Partial<EndpointTitleStatus>;
  titleDocuments: EndpointTitleDocument[];
  titleDocument: Partial<EndpointDownloadedTitleDocument>;
  getTitles: GetTitlesFunction;
  getTitleStatus: GetTitleStatusFunction;
  getTitleDocuments: GetTitleDocumentsFunction;
  getTitleDocument: GetTitleDocumentFunction;
  uploadTitleDocument: UploadTitleDocumentFunction;
  getTitleCompanies: GetTitleCompaniesFunction;
  createTitleCompany: CreateTitleCompanyFunction;
  removeListing:RemoveTitleCompanyFunction
}

export const useTitleStore = create<TitleStore>((set) => ({
  titles: [],
  titleCompanies: [],
  titleStatus: {},
  titleDocuments: [],
  titleDocument: "",
  getTitles: async (...args: Parameters<GetTitlesFunction>) => {
    try {
      const titles = await TitleService.getTitles(...args);
      set({ titles });

      return titles;
    } catch (error) {
      throw error;
    }
  },
  getTitleStatus: async (...args: Parameters<GetTitleStatusFunction>) => {
    try {
      const titleStatus = await TitleService.getTitleStatus(...args);
      set({ titleStatus });

      return titleStatus;
    } catch (error) {
      throw error;
    }
  },
  getTitleDocuments: async (...args: Parameters<GetTitleDocumentsFunction>) => {
    try {
      const titleDocuments = await TitleService.getTitleDocuments(...args);
      set({ titleDocuments });

      return titleDocuments;
    } catch (error) {
      throw error;
    }
  },
  getTitleDocument: async (...args: Parameters<GetTitleDocumentFunction>) => {
    try {
      const titleDocument = await TitleService.getTitleDocument(...args);
      set({ titleDocument });

      return titleDocument;
    } catch (error) {
      throw error;
    }
  },
  uploadTitleDocument: async (
    ...args: Parameters<UploadTitleDocumentFunction>
  ) => {
    try {
      const response = await TitleService.uploadTitleDocument(...args);

      return response;
    } catch (error) {
      throw error;
    }
  },
  getTitleCompanies: async () => {
    try {
      const titleCompanies: TitleCompanies[] =
        await TitleService.getTitleCompanies();
      set({ titleCompanies });
      return titleCompanies;
    } catch (error) {
      throw error;
    }
  },
  createTitleCompany: async (
    ...args: Parameters<CreateTitleCompanyFunction>
  ) => {
    try {
      return await TitleService.createTitleCompany(...args);
    } catch (error) {
      throw error;
    }
  },
  removeListing: async (...args: Parameters<RemoveTitleCompanyFunction>) => {
    try {
      const response = await TitleService.removeTitleCompany(...args);

      return response;
    } catch (error) {
      throw error;
    }
  },
}));
